import PropTypes from 'prop-types'
import { useCallback, useMemo } from 'react'

import { DndSortableList, useSortableDndListItem } from '@/components/SortableDnd'

import SortableItem from './SortableItem'

const propTypes = {
  items: PropTypes.array,
  onChangeSortable: PropTypes.func,
  options: PropTypes.any,
  onToggleManage: PropTypes.func,
  profilesCollapse: PropTypes.array,
  onChangeCollapse: PropTypes.func,
  pendingSave: PropTypes.bool,
  getLabel: PropTypes.func,
}

const idOf = p => p.key == null ? 'path-key-null' : String(p.key)

function Row({ item, options, onToggleManage, index, isCollapse, onChangeCollapse, pendingSave, getLabel, sortableId, disabledSort }) {
  const dnd = useSortableDndListItem(sortableId, { disabled: disabledSort })

  return <SortableItem
    item={item}
    options={options}
    onToggleManage={onToggleManage}
    index={index}
    isCollapse={isCollapse}
    onChangeCollapse={onChangeCollapse}
    pendingSave={pendingSave}
    getLabel={getLabel}
    dnd={dnd}
  />
}

export default function SortableList({ items, onChangeSortable, options, onToggleManage, profilesCollapse, onChangeCollapse, pendingSave, getLabel }) {
  const sortableIds = useMemo(() => items.map(idOf), [items])

  const onSortEnd = useCallback(newSort => {
    onChangeSortable(newSort.map(p => p.key))
  }, [onChangeSortable])

  return <DndSortableList itemIds={sortableIds} onSortEnd={onSortEnd} items={items}>
    <ul className="flex flex-col gap-4">
      {items.map((path, index) => <Row
        key={idOf(path)}
        sortableId={idOf(path)}
        item={path}
        options={options}
        onToggleManage={onToggleManage}
        index={index}
        isCollapse={profilesCollapse.includes(path.key)}
        onChangeCollapse={onChangeCollapse}
        pendingSave={pendingSave}
        getLabel={getLabel}
        disabledSort={path.key === null}
      />,
      )}
    </ul>
  </DndSortableList>
}

SortableList.propTypes = propTypes
SortableList.defaultProps = {}
